<template>
  <!-- <div> -->
    
    <!-- banner-style-three -->
    <section class="banner-style-two banner-style-three">
      <div class="pattern-layer" style="background-image: url(/assets/images/shape/shape-24.png);"></div>
      <div class="banner-carousel owl-theme owl-carousel owl-dots-none">
            <div class="slide-item">
                <div class="auto-container">
                    <div class="inner-box">
                        <div class="image-box">
                            <figure class="image"><img src="assets/images/banner/etp.png" alt="banner1"></figure>
                        </div>
                        <div class="content-box">
                            <h2>Effluent<br>Treatment Plant</h2>
                            <p>A effluent treatment plant combines multiple technologies-like membrane filtration, sequencing batch reactors, constructed wetlands, MBBRs, anaerobic and aerobic processes-tailored to wastewater type and treatment goals.</p>
                            <div class="btn-box clearfix">
                                <router-link to="/" class="theme-btn btn-one">Discover</router-link>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
          
            <div class="slide-item">
                <div class="auto-container">
                    <div class="inner-box">
                        <div class="image-box">
                            <figure class="image"><img src="assets/images/banner/mbr.png" alt="banner2"></figure>
                        </div>
                        <div class="content-box">
                            <h2>Membranes<br>BioReactor (MBR)</h2>
                            <p>Membrane Bioreactor (MBR) technology is an advanced wastewater treatment method that integrates biological treatment with membrane filtration.</p>
                            <div class="btn-box clearfix">
                                <router-link to="/" class="theme-btn btn-one">Discover</router-link>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>

            <div class="slide-item">
                <div class="auto-container">
                    <div class="inner-box">
                        <div class="image-box">
                            <figure class="image"><img src="assets/images/banner/banner3.png" alt="banner"></figure>
                        </div>
                        <div class="content-box">
                            <h2>Reverse<br>Osmosis Plant</h2>
                            <p>Reverse osmosis (R.O.) is a water filtration method that removes salts and impurities by forcing water through a semi-permeable membrane under high pressure.</p>
                            <div class="btn-box clearfix">
                                <router-link to="/" class="theme-btn btn-one">Discover</router-link>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
      </div>
    </section>

    
    <!-- feature-section -->
    <section class="feature-section light alternat-2 centred">
        <div class="pattern-layer">
            <div class="pattern-1" style="background-image: url(assets/images/shape/shape-25.png);"></div>
            <div class="pattern-2" style="background-image: url(assets/images/shape/shape-26.png);"></div>
        </div>
        <div class="auto-container">
            <div class="inner-container wow fadeInLeft animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                <div class="title-text">
                    <h2>Why Choose Akshar Watertech</h2>
                </div>
                <div class="row clearfix">
                    <div class="col-lg-3 col-md-6 col-sm-12 feature-block">
                        <div class="feature-block-one">
                            <div class="inner-box">
                                <div class="shape" style="background-image: url(assets/images/shape/shape-27.png);"></div>
                                <div class="icon-box"><i class="fas fa-user-tie"></i></div>
                                <h4>Experience - Expertise</h4>
                                <p>Specializes in industrial water and wastewater treatment Pants And Chemicals, And using advanced technology with Total water solutions.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12 feature-block">
                        <div class="feature-block-one">
                            <div class="inner-box">
                                <div class="shape" style="background-image: url(assets/images/shape/shape-27.png);"></div>
                                <div class="icon-box"><i class="fas fa-handshake"></i></div>
                                <h4>Solutions - Services</h4>
                                <p>Akshar Watertech provides comprehensive water and wastewater treatment solutions across commercial, industrial, and municipal sectors.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12 feature-block">
                        <div class="feature-block-one">
                            <div class="inner-box">
                                <div class="shape" style="background-image: url(assets/images/shape/shape-27.png);"></div>
                                <div class="icon-box"><i class="fas fa-lightbulb"></i></div>
                                <h4>Quality - Innovation</h4>
                                <p>Using advanced technology to create products that are both energy-efficient and while minimizing their environmental impact.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12 feature-block">
                        <div class="feature-block-one">
                            <div class="inner-box">
                                <div class="icon-box"><i class="fas fa-smile"></i></div>
                                <h4>Customer Satisfaction</h4>
                                <p>Positive reviews highlight their excellent, fast, and satisfactory service, with a focus on meeting individual client needs.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- feature-section end -->

    <section class="about-section">
        <div class="container">
            <div class="title-text text-center pb-5">
                <h2>Total Water and Environment Management Solutions</h2>
            </div>
            <div class="row align-items-center clearfix">
                <div class="col-lg-6 col-md-12 col-sm-12 image-column">
                    <figure class="image-box clearfix wow fadeInLeft animated" data-wow-delay="00ms" data-wow-duration="1500ms"><img src="assets/images/chart/full_chart.gif" alt="chart"></figure>
                </div>
                <!-- <div class="col-lg-6 col-md-12 col-sm-12 sidebar-side">
                    <div class="service-sidebar">
                        <div class="category-widget">
                            <h3>Our Products</h3>
                            <ul class="category-list clearfix">
                                <li><router-link to="/"><i class="fas fa-caret-right"></i>Industrial R.O. Plant</router-link></li>
                                <li><router-link to="/"><i class="fas fa-caret-right"></i>Softener-DM Plant</router-link></li>
                                <li><router-link to="/"><i class="fas fa-caret-right"></i>Consulting Services</router-link></li>
                                <li><router-link to="/"><i class="fas fa-caret-right"></i>Water Treatment Plants</router-link></li>
                                <li><router-link to="/"><i class="fas fa-caret-right"></i>Ultra-Nano Filtration Plant</router-link></li>
                                <li><router-link to="/"><i class="fas fa-caret-right"></i>AMC & Revamping Projects</router-link></li>
                                <li><router-link to="/"><i class="fas fa-caret-right"></i>Boiler Water Treatment Chemical</router-link></li>
                                <li><router-link to="/"><i class="fas fa-caret-right"></i>Cooling Tower Water Treatment Chemical</router-link></li>
                                <li><router-link to="/"><i class="fas fa-caret-right"></i>ETP-STP Plant, Membrane Bioreactor Plants (MBR)</router-link></li>
                                <li><router-link to="/"><i class="fas fa-caret-right"></i>All Type of Water & Waste Water Treatment Chemical</router-link></li>
                            </ul>
                        </div>
                    </div>
                </div> -->
                <div class="col-lg-6 col-md-12 col-sm-12 content-column d-flex justify-content-end">
                    <div class="content_block_4">
                        <div class="content-box">
                            <ul class="list clearfix">
                                <li><router-link to="/">Industrial R.O. Plant</router-link></li>
                                <li><router-link to="/">Softener-DM Plant</router-link></li>
                                <li><router-link to="/">Consulting Services</router-link></li>
                                <li><router-link to="/">Water Treatment Plants</router-link></li>
                                <li><router-link to="/">Ultra-Nano Filtration Plant</router-link></li>
                                <li><router-link to="/">AMC & Revamping Projects</router-link></li>
                                <li><router-link to="/">Boiler Water Treatment Chemical</router-link></li>
                                <li><router-link to="/">Cooling Tower Water Treatment Chemical</router-link></li>
                                <li><router-link to="/">ETP-STP Plant, Membrane Bioreactor Plants (MBR)</router-link></li>
                                <li><router-link to="/">All Type of Water & Waste Water Treatment Chemical</router-link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- <section class="service-page-section centred">
        <div class="auto-container">
            <div class="title-text pb-4">
                <h2>Our Products</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-4 col-md-6 col-sm-12 service-block">
                    <div class="service-block-two wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                        <div class="inner-box">
                            <div class="icon-box">
                                <div class="icon"><i class="flaticon-water-bottle-1"></i></div>
                            </div>
                            <h4><router-link to="/">Industrial R.O. Plant</router-link></h4>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 service-block">
                    <div class="service-block-two wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                        <div class="inner-box">
                            <div class="icon-box">
                                <div class="icon"><i class="flaticon-water-bottle-1"></i></div>
                            </div>
                            <h4><router-link to="/">Softener-DM Plant</router-link></h4>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 service-block">
                    <div class="service-block-two wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                        <div class="inner-box">
                            <div class="icon-box">
                                <div class="icon"><i class="flaticon-water-bottle-1"></i></div>
                            </div>
                            <h4><router-link to="/">Consulting Services</router-link></h4>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 service-block">
                    <div class="service-block-two wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                        <div class="inner-box">
                            <div class="icon-box">
                                <div class="icon"><i class="flaticon-water-bottle-1"></i></div>
                            </div>
                            <h4><router-link to="/">Water Treatment Plants</router-link></h4>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 service-block">
                    <div class="service-block-two wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                        <div class="inner-box">
                            <div class="icon-box">
                                <div class="icon"><i class="flaticon-water-bottle-1"></i></div>
                            </div>
                            <h4><router-link to="/">Ultra-Nano Filtration Plant</router-link></h4>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 service-block">
                    <div class="service-block-two wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                        <div class="inner-box">
                            <div class="icon-box">
                                <div class="icon"><i class="flaticon-water-bottle-1"></i></div>
                            </div>
                            <h4><router-link to="/">AMC & Revamping Projects</router-link></h4>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 service-block">
                    <div class="service-block-two wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                        <div class="inner-box">
                            <div class="icon-box">
                                <div class="icon"><i class="flaticon-water-bottle-1"></i></div>
                            </div>
                            <h4><router-link to="/">Boiler Water Treatment Chemical</router-link></h4>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 service-block">
                    <div class="service-block-two wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                        <div class="inner-box">
                            <div class="icon-box">
                                <div class="icon"><i class="flaticon-water-bottle-1"></i></div>
                            </div>
                            <h4><router-link to="/">Cooling Tower Water Treatment Chemical</router-link></h4>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 service-block">
                    <div class="service-block-two wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                        <div class="inner-box">
                            <div class="icon-box">
                                <div class="icon"><i class="flaticon-water-bottle-1"></i></div>
                            </div>
                            <h4><router-link to="/">ETP-STP Plant, Membrane Bioreactor Plants (MBR)</router-link></h4>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 service-block">
                    <div class="service-block-two wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                        <div class="inner-box">
                            <div class="icon-box">
                                <div class="icon"><i class="flaticon-water-bottle-1"></i></div>
                            </div>
                            <h4><router-link to="/">All Type of Water & Waste Water Treatment Chemical</router-link></h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> -->

    <!-- testimonial-style-two -->
    <!-- <section class="testimonial-style-two centred bg-color-1">
        <div class="thumb-box">
            <div class="thumb thumb-1"><img src="assets/images/resource/thumb-1.jpg" alt=""></div>
            <div class="thumb thumb-2"><img src="assets/images/resource/thumb-2.jpg" alt=""></div>
            <div class="thumb thumb-3"><img src="assets/images/resource/thumb-3.jpg" alt=""></div>
            <div class="thumb thumb-4"><img src="assets/images/resource/thumb-4.jpg" alt=""></div>
            <div class="thumb thumb-5"><img src="assets/images/resource/thumb-5.jpg" alt=""></div>
            <div class="thumb thumb-6"><img src="assets/images/resource/thumb-6.jpg" alt=""></div>
        </div>
        <div class="pattern-layer">
            <div class="pattern-1" style="background-image: url(assets/images/shape/shape-35.png);"></div>
            <div class="pattern-2" style="background-image: url(assets/images/shape/shape-36.png);"></div>
        </div>
        <div class="map-layer" style="background-image: url(assets/images/icons/map-1.png);"></div>
        <div class="auto-container">
            <div class="sec-title">
                <h2>What Our Client are Saying <br />About Acuasafe</h2>
            </div>
            <div class="row clearfix">
                <div class="col-xl-8 col-lg-12 col-md-12 offset-xl-2">
                    <div class="single-item-carousel owl-carousel owl-theme dots-style-one owl-nav-none">
                        <div class="testimonial-block-two">
                            <div class="inner-box">
                                <figure class="author-thumb"><img src="assets/images/resource/testimonial-1.jpg" alt=""></figure>
                                <div class="inner">
                                    <ul class="rating clearfix">
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                    </ul>
                                    <p>Lorem ipsum dolor amet consectur adicing elit sed do usmod tempor incididunt enimad minim veniam quis nostrud exer citation laboris nisi aliquip commodo perspiciatis unde omnis natus.</p>
                                    <h5>Nicolas Lawson</h5>
                                    <span class="designation">Designer</span>
                                </div>
                            </div>
                        </div>
                        <div class="testimonial-block-two">
                            <div class="inner-box">
                                <figure class="author-thumb"><img src="assets/images/resource/testimonial-2.jpg" alt=""></figure>
                                <div class="inner">
                                    <ul class="rating clearfix">
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                    </ul>
                                    <p>Lorem ipsum dolor amet consectur adicing elit sed do usmod tempor incididunt enimad minim veniam quis nostrud exer citation laboris nisi aliquip commodo perspiciatis unde omnis natus.</p>
                                    <h5>Michael Bean</h5>
                                    <span class="designation">Manager</span>
                                </div>
                            </div>
                        </div>
                        <div class="testimonial-block-two">
                            <div class="inner-box">
                                <figure class="author-thumb"><img src="assets/images/resource/testimonial-1.jpg" alt=""></figure>
                                <div class="inner">
                                    <ul class="rating clearfix">
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                        <li><i class="fas fa-star"></i></li>
                                    </ul>
                                    <p>Lorem ipsum dolor amet consectur adicing elit sed do usmod tempor incididunt enimad minim veniam quis nostrud exer citation laboris nisi aliquip commodo perspiciatis unde omnis natus.</p>
                                    <h5>Jennifer Lawrence</h5>
                                    <span class="designation">CEO Founder</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> -->
    <!-- testimonial-style-two end -->

    <!-- video-section -->
    <!-- <section class="video-section">
        <div class="auto-container">
            <div class="inner-container">
                <div class="video-inner">
                    <div class="inner-box" style="background-image: url(assets/images/background/video-1.jpg);">
                            <div class="video-btn">
                            <a href="https://www.youtube.com/watch?v=nfP5N9Yc72A&amp;t=28s" class="lightbox-image" data-caption=""><i class="fas fa-play"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> -->
    <!-- video-section end -->
    
    <!-- Continue with other sections -->
  <!-- </div> -->
</template>

<script setup>
import { onMounted } from 'vue'
import { useHead } from '@unhead/vue'
useHead({
  title: 'Akshar',
  meta: [
    {
      name: 'description',
      content: 'Welcome to Akshar.',
    },
  ],
})

onMounted(() => {
//   const mainScript = document.createElement('script')
//   mainScript.src = '/assets/js/script.js'
//   document.body.appendChild(mainScript)

    const scriptId = 'script-js-script'

    // Check if the script already exists
    const existingScript = document.getElementById(scriptId)

    if (existingScript) {
    // Replace it: remove and re-add
    existingScript.remove()
    }

    // Create and append a fresh script
    const newScript = document.createElement('script')
    newScript.src = '/assets/js/script.js'
    newScript.id = scriptId
    document.body.appendChild(newScript)
})
</script>
<style scoped>
.about-section .title-text h2 {
        font-size: 40px;
    line-height: 55px;
    font-weight: 700;
}
.content_block_4 .content-box .list li a{
    color: unset;
}
</style>